import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

export const fetchFavorites = createAsyncThunk(
  'favorites/fetchFavorites',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/auth/favorites/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Не удалось загрузить избранное");
    }
  }
);

export const toggleFavorite = createAsyncThunk(
  'favorites/toggleFavorite',
  async (product, { getState, rejectWithValue }) => {
    const { favorites } = getState();
    const existing = favorites.items.find(item => item.product === product.id);

    try {
      if (existing) {
        await api.delete(`/auth/favorites/${existing.id}/`);
        return { productId: product.id, removed: true };
      } else {
        const response = await api.post('/auth/favorites/', { product: product.id });
        return { item: response.data, removed: false };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || "Не удалось обновить избранное");
    }
  }
);

const initialState = {
  items: [],
  status: 'idle',
  error: null,
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavorites.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchFavorites.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.results || action.payload;
      })
      .addCase(fetchFavorites.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(toggleFavorite.fulfilled, (state, action) => {
        if (action.payload.removed) {
          state.items = state.items.filter(item => item.product !== action.payload.productId);
        } else {
          state.items.push(action.payload.item);
        }
      });
  },
});

export default favoritesSlice.reducer;
